var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DataTable", {
        attrs: {
          data: _vm.data,
          header: _vm.headerDefinition,
          "entity-name": "feeling dataset"
        },
        on: {
          addItem: _vm.addItem,
          updateItem: _vm.updateItem,
          deleteItem: _vm.deleteItem
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }